import {
    GET_ALL_REPORTS,
    SET_MONTH,
    SET_YEAR,
    GET_JOBPACK_REPORTS,
    GET_HSQE_TEMPLATE,
    SET_SPECIFIC_TEMPLATE,
    GET_USERS_PROFILE
} from "./types";

import firebase from "firebase/app";

export const getReports = () => {
    return (dispatch) => {
        dispatch({ type: GET_ALL_REPORTS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/reports/`)
                        .on("value", (snapshot) => {
                            return dispatch({
                                type: GET_ALL_REPORTS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else dispatch({ type: GET_ALL_REPORTS.FAIL });
            });
        } catch {
            dispatch({ type: GET_ALL_REPORTS.FAIL });
        }
    };
};
export const getJobPackReports = () => {
    return (dispatch) => {
        dispatch({ type: GET_JOBPACK_REPORTS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/jobpacks/`)
                        .on("value", (snapshot) => {
                            return dispatch({
                                type: GET_JOBPACK_REPORTS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else dispatch({ type: GET_JOBPACK_REPORTS.FAIL });
            });
        } catch {
            dispatch({ type: GET_JOBPACK_REPORTS.FAIL });
        }
    };
};

export const setMonth = (date = false) => {
    return (dispatch) => {
        dispatch({ type: SET_MONTH, payload: date });
    };
};
export const setYear = (date = false) => {
    return (dispatch) => {
        dispatch({ type: SET_YEAR, payload: date });
    };
};

export const getHsqeTemplates = () => {
    return (dispatch) => {
        dispatch({ type: GET_HSQE_TEMPLATE.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/report_templates`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_HSQE_TEMPLATE.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_HSQE_TEMPLATE.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_HSQE_TEMPLATE.FAIL });
        }
    };
};

export const specificTemplate = (data) => {
    let reference = data.replace(/ /g,"_");
    let id = `custom_${reference}`
    return (dispatch) => {
        dispatch({ type: SET_SPECIFIC_TEMPLATE.REQUEST });
        try {
            dispatch({
                type: SET_SPECIFIC_TEMPLATE.SUCCESS,
                payload: id,
            });
        }
        catch{
            dispatch({ type: SET_SPECIFIC_TEMPLATE.FAIL });
        }
    }
}

export const getUsersProfile = () => {
    return (dispatch) => {
        dispatch({ type: GET_USERS_PROFILE.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_USERS_PROFILE.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_USERS_PROFILE.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_USERS_PROFILE.FAIL });
        }
    };
};